import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { GetAllValidationsAPI } from "api/validationApi";
import { DeleteValidationAPI } from "api/validationApi";
import { CreateValidationAPI } from "api/validationApi";
import { GetValidationsByPlaceIdAPI } from "api/validationApi";

const handleThunkError = (err, rejectWithValue) => {
  return rejectWithValue(
    err?.response?.data || {
      success: false,
      message: "Something went wrong",
    }
  );
};

const initialState = {
  allValidations: [],
  validations: [],
  loading: false,
};

export const createValidation = createAsyncThunk(
  "validations/createValidation",
  async (data, { rejectWithValue }) => {
    console.log(data, "<==data");
    try {
      const response = await CreateValidationAPI(data);
      return response.data;
    } catch (err) {
      console.log("validation error ======>", err);
      return handleThunkError(err, rejectWithValue);
    }
  }
);

export const deleteValidation = createAsyncThunk(
  "validations/deleteValidation",
  async (data, { rejectWithValue }) => {
    console.log(data, "<==data");
    try {
      const response = await DeleteValidationAPI(data);
      return response.data;
    } catch (err) {
      console.log("Delete error ======>", err);
      return handleThunkError(err, rejectWithValue);
    }
  }
);

export const getValidationsByPlaceId = createAsyncThunk(
  "validations/getValidationsByPlaceId",
  async (data, { rejectWithValue }) => {
    try {
      const response = await GetValidationsByPlaceIdAPI(data);
      return response.data;
    } catch (err) {
      console.log("Get validation error ======>", err);
      return handleThunkError(err, rejectWithValue);
    }
  }
);

export const getAllValidations = createAsyncThunk(
  "validations/getAllValidations",
  async (data, { rejectWithValue }) => {
    try {
      const response = await GetAllValidationsAPI(data);
      return response.data;
    } catch (err) {
      console.log("Get validation error ======>", err);
      return handleThunkError(err, rejectWithValue);
    }
  }
);

export const validationSlice = createSlice({
  name: "validations",
  initialState,
  reducers: {},
  extraReducers: (builder) =>
    builder
      .addCase(getAllValidations.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllValidations.fulfilled, (state, { payload }) => {
        state.allValidations = payload.validation;
        state.loading = false;
      })
      .addCase(getAllValidations.rejected, (state) => {
        state.loading = false;
      }),
});

export default validationSlice.reducer;
